var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-y-12 bg-white px-20 py-16"},[_c('h3',{staticClass:"text-lg leading-6 font-medium text-gray-900"},[_vm._v(" Order #"+_vm._s(_vm.accOrder.number)+" ("+_vm._s(_vm.dateCreated)+") ")]),_c('PreviewCustomerDetails',{attrs:{"acc-order":_vm.accOrder}}),_c('PreviewOrderDetails',{attrs:{"acc-order":_vm.accOrder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }